/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface DonationPurposeBase
 */
export interface DonationPurposeBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationPurposeBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationPurposeBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationPurposeBase
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationPurposeBase
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationPurposeBase
   */
  imageURL?: string;
}

export interface DonationPurposeBase extends DonationPurposeBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationPurposeBase
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationPurposeBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationPurposeBase
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationPurposeBase
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationPurposeBase
   */
  imageURL?: string;
}

export interface DonationPurposeBaseTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof DonationPurposeBase
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationPurposeBase
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationPurposeBase
   */
  showInCheckout?: boolean;
  showInCheckoutIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationPurposeBase
   */
  portalDescription?: string;
  portalDescriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationPurposeBase
   */
  imageURL?: string;
  imageURLIsSet: boolean;
}

transformDatesMap.set(
  "DonationPurposeBase",
  function (model: DonationPurposeBase) {},
);

export type DonationPurposeBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  showInCheckout: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  portalDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  imageURL: PropertyMeta<MetaTypeBase<string>>;
}>;

export var DonationPurposeBaseMeta: DonationPurposeBaseMetaI =
  {} as DonationPurposeBaseMetaI;
DonationPurposeBaseMeta = typeMeta("DonationPurposeBase", {
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  showInCheckout: propertyMeta(
    "showInCheckout",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  portalDescription: propertyMeta(
    "portalDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  imageURL: propertyMeta("imageURL", false, false, false, MetaTypesBase.string),
});

const metaI = DonationPurposeBaseMeta;

registerMeta(() => {});

export class DonationPurposeBaseTracked implements DonationPurposeBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  showInCheckout__I?: boolean = undefined;
  showInCheckoutIsSet: boolean = false;
  set showInCheckout(v: undefined | boolean) {
    if (v !== undefined) {
      this.showInCheckout__I = v;
      this.showInCheckoutIsSet = true;
    } else {
      this.showInCheckout__I = v || undefined;
      this.showInCheckoutIsSet = false;
    }
    this.changeTracker = true;
  }
  get showInCheckout() {
    return this.showInCheckout__I;
  }
  portalDescription__I?: string = undefined;
  portalDescriptionIsSet: boolean = false;
  set portalDescription(v: undefined | string) {
    if (v !== undefined) {
      this.portalDescription__I = v;
      this.portalDescriptionIsSet = true;
    } else {
      this.portalDescription__I = v || undefined;
      this.portalDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get portalDescription() {
    return this.portalDescription__I;
  }
  imageURL__I?: string = undefined;
  imageURLIsSet: boolean = false;
  set imageURL(v: undefined | string) {
    if (v !== undefined) {
      this.imageURL__I = v;
      this.imageURLIsSet = true;
    } else {
      this.imageURL__I = v || undefined;
      this.imageURLIsSet = false;
    }
    this.changeTracker = true;
  }
  get imageURL() {
    return this.imageURL__I;
  }
  constructor(config?: DonationPurposeBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: DonationPurposeBaseOptional,
    options?: AssignOptions,
  ): DonationPurposeBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.showInCheckout &&
      this.showInCheckoutApplyFilter(optionsRequired.filter)
    ) {
      this.showInCheckout = config.showInCheckout;
      if (optionsRequired.unassign) this.showInCheckoutIsSet = false;
      else this.showInCheckoutIsSet = true;
    }
    if (
      config.portalDescription &&
      this.portalDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.portalDescription = config.portalDescription;
      if (optionsRequired.unassign) this.portalDescriptionIsSet = false;
      else this.portalDescriptionIsSet = true;
    }
    if (config.imageURL && this.imageURLApplyFilter(optionsRequired.filter)) {
      this.imageURL = config.imageURL;
      if (optionsRequired.unassign) this.imageURLIsSet = false;
      else this.imageURLIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationPurposeBaseTrackedI {
    const cloned = {} as DonationPurposeBaseTrackedI;
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.showInCheckoutIsSetDeep() &&
      this.showInCheckoutApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.showInCheckoutIsSet = true;
      cloned.showInCheckout = this.showInCheckout;
    } else {
      //cloned.showInCheckoutIsSet = false
    }
    if (
      this.portalDescriptionIsSetDeep() &&
      this.portalDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.portalDescriptionIsSet = true;
      cloned.portalDescription = this.portalDescription;
    } else {
      //cloned.portalDescriptionIsSet = false
    }
    if (
      this.imageURLIsSetDeep() &&
      this.imageURLApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.imageURLIsSet = true;
      cloned.imageURL = this.imageURL;
    } else {
      //cloned.imageURLIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationPurposeBaseTrackedI {
    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.showInCheckoutApplyFilter(filter))
      this.showInCheckoutIsSet = false;

    if (!this.portalDescriptionApplyFilter(filter))
      this.portalDescriptionIsSet = false;

    if (!this.imageURLApplyFilter(filter)) this.imageURLIsSet = false;

    return this;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationPurposeBaseMeta.active,
      DonationPurposeBaseMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationPurposeBaseMeta.displayOrder,
      DonationPurposeBaseMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  showInCheckoutApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationPurposeBaseMeta.showInCheckout,
      DonationPurposeBaseMeta,
      this.showInCheckout,
      this,
    );
  }
  showInCheckoutIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.showInCheckoutIsSet && this.showInCheckoutApplyFilter(filter))
      return true;

    return false;
  }
  portalDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationPurposeBaseMeta.portalDescription,
      DonationPurposeBaseMeta,
      this.portalDescription,
      this,
    );
  }
  portalDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.portalDescriptionIsSet &&
      this.portalDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  imageURLApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationPurposeBaseMeta.imageURL,
      DonationPurposeBaseMeta,
      this.imageURL,
      this,
    );
  }
  imageURLIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.imageURLIsSet && this.imageURLApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.showInCheckoutIsSetDeep(filter)) return true;
    if (this.portalDescriptionIsSetDeep(filter)) return true;
    if (this.imageURLIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
